import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 mb-10">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-book-read-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading font-bold text-xl tracking-wide text-white">虚空韩漫</span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
                虚空韩漫网 —— 致力于提供最优质的韩漫在线阅读体验。每日更新最新韩国漫画，无删减下拉式阅读，让您畅享韩漫世界。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">漫画分类</h4>
              <div className="flex flex-col gap-2.5">
                {Object.entries(categories).filter(([k]) => k !== 'all').map(([slug, cat]) => (
                  <Link key={slug} to={`/category/${slug}`} className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap cursor-pointer">{cat.name}</Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/about" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">热门排行</a>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">最新更新</a>
              </div>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">帮助中心</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">常见问题</a>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">使用指南</a>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">版权声明</a>
                <a href="#" className="text-foreground-300 hover:text-white text-sm transition-colors whitespace-nowrap">隐私政策</a>
              </div>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-white text-sm mb-4">关注我们</h4>
              <div className="flex gap-3 mb-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-links-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-movie-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
              <p className="text-foreground-300 text-xs mb-3">订阅我们的更新通知</p>
              <NewsletterForm />
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; {siteInfo.founded}-2026 {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-foreground-200 text-xs transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-foreground-400 hover:text-foreground-200 text-xs transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-foreground-400 hover:text-foreground-200 text-xs transition-colors whitespace-nowrap">Cookie 设置</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function NewsletterForm() {
  return (
    <form
      id="newsletter-form"
      onSubmit={(e) => { e.preventDefault(); }}
      className="flex gap-2"
    >
      <input
        type="text"
        name="phone_alt"
        className="antispam-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <input
        type="email"
        name="email"
        placeholder="您的邮箱"
        className="flex-1 px-3 py-2 text-xs rounded-lg bg-foreground-800 border border-foreground-700 text-white placeholder:text-foreground-400 outline-none focus:border-primary-400"
      />
      <button type="submit" className="px-4 py-2 text-xs font-medium rounded-lg bg-primary-500 hover:bg-primary-600 text-white transition-colors whitespace-nowrap cursor-pointer">
        订阅
      </button>
    </form>
  );
}